export const roomPeriods = [
  'today',
  'last_week',
  'last_month',
  'last_3_months',
  'last_6_months',
  'last_year',
]
